import UntypedCircularLoader from './CircularLoader';

/** @deprecated use Spinner from "@ci/atoms" */
const CircularLoader = UntypedCircularLoader as any;

export default CircularLoader;
